import { useQuery } from 'react-query'
import QUERIES from 'api/queries'
import { getOrganizationById, getOrganizationMembers } from './services'
import { IOrganization } from './models'

export const useOrganizationById = (orgId?: IOrganization['id']) =>
	useQuery([QUERIES.organizationById, orgId], async () => (orgId ? await getOrganizationById(orgId) : undefined), {
		enabled: !!orgId,
	})

export const useOrganizationMembers = (orgId?: IOrganization['id']) =>
	useQuery(
		[QUERIES.organizationMembers, orgId],
		async () => (orgId ? await getOrganizationMembers(orgId) : undefined),
		{
			enabled: !!orgId,
		}
	)
